import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FLOOR_EDIT } from '../../../../../constants/AccomodationConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_ACCOMMODATIONS,
} from '../../../../../constants/RoleConsts';
import DetailViewLayout from '../../../../../shared/detail-view-layout/Detail-View-Layout';
import {
  allCategoriesSelector,
  allFloorsSelector,
  allRoomsSelector,
  allRoomTypesSelector,
} from '../../../../property/propertySlice';
import './Floor-View.scss';

const FloorView = (props) => {
  const { floor, onViewToggle, hotelId, toggleDrawer, permissions } = props;
  const [selectedFloor, setSelectedFloor] = useState();
  const originalRoomTypes = useSelector(allRoomTypesSelector);
  const originalFloors = useSelector(allFloorsSelector);
  const originalRooms = useSelector(allRoomsSelector);
  const originalCategories = useSelector(allCategoriesSelector);

  useEffect(() => {
    // retreiving selected category details from api
    let floorObj = {
      ...originalFloors.find((tempFloor) => tempFloor.id === floor.id),
    };
    floorObj['roomTypes'] = retrieveRoomTypes(floorObj.roomRangeList);
    const roomRangeDetails = getRoomsDetails(floorObj.roomRangeList);
    floorObj['noOfRooms'] = roomRangeDetails.count;
    floorObj['roomRanges'] = roomRangeDetails.rangeString;
    setSelectedFloor(floorObj);
  }, [hotelId, originalFloors]);

  const retrieveRoomTypes = (roomRangeList) => {
    let roomList = [];
    for (let roomRange of roomRangeList) {
      for (let i = roomRange.rangeFrom; i <= roomRange.rangeTo; i++) {
        roomList.push(i);
      }
    }

    return originalRoomTypes.filter((tempRoomType) =>
      originalRooms
        .filter((room) => roomList.some((tempRoom) => tempRoom.toString() === room.number))
        .some((val) => val.roomTypeId === tempRoomType.id),
    );
  };

  const retrieveRoomTypesString = (roomTypes) => {
    return roomTypes.map((e) => e.name).join(', ');
  };

  const getRoomsDetails = (roomRangeList) => {
    let count = 0;
    let rangeString = '-';
    for (let range of roomRangeList) {
      count = count + range.rangeTo - range.rangeFrom + 1;
      rangeString =
        rangeString === '-'
          ? range.rangeFrom + ' - ' + range.rangeTo
          : rangeString + ', ' + range.rangeFrom + ' - ' + range.rangeTo;
    }

    return { count: count, rangeString: rangeString };
  };

  const onClickEdit = (event) => {
    toggleDrawer(FLOOR_EDIT, true, selectedFloor);
  };

  const retreiveCategories = (roomTypes) => {
    return originalCategories.filter((cat) =>
      roomTypes.some((tempRoomType) => tempRoomType.categoryId === cat.id),
    );
  };

  const renderScreen = () => {
    return (
      <>
        <div className='row mx-4 mt-4'>
          <div className='col-md-12 mb-4'>
            <span className='page-title-secondary'>Details</span>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>Floor Name</div>
            <div className='details-value preview-breaks'>{selectedFloor.name}</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Floor Number</div>
            <div className='details-value'>{selectedFloor.number}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>No.of Categories</div>
            <div className='details-value'>
              {selectedFloor.roomTypes ? retreiveCategories(selectedFloor.roomTypes).length : 0}
            </div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Room Types</div>
            <div className='details-value'>
              {selectedFloor.roomTypes && retrieveRoomTypesString(selectedFloor.roomTypes)
                ? retrieveRoomTypesString(selectedFloor.roomTypes)
                : '---'}
            </div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>No.of Rooms</div>
            <div className='details-value'>{selectedFloor.noOfRooms}</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>Room Numbers</div>
            <div className='details-value'>{selectedFloor.roomRanges}</div>
          </div>
        </div>
        <div className='row mx-4 mt-4'>
          <div className='col-md-4'>
            <div className='details-label'>No.of Occupied Rooms</div>
            {/* TODO: Value from DB should be added after reservation module gets completed */}
            <div className='details-value'>---</div>
          </div>
          <div className='col-md-8'>
            <div className='details-label'>No.of Vacant Rooms</div>
            {/* TODO: Value from DB should be added after reservation module gets completed */}
            <div className='details-value'>---</div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {selectedFloor && (
        <DetailViewLayout
          onClickEdit={onClickEdit}
          renderScreen={renderScreen}
          onViewToggle={onViewToggle}
          title={selectedFloor.name}
          createdUserId={selectedFloor.createdBy}
          isEditable={
            permissions[RBAC_TYPE_HOTEL_ACCOMMODATIONS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
          }
        />
      )}
    </>
  );
};

export default FloorView;
